export default __webpack_public_path__ + "static/media/Bandit's Gloves of World's Edge.73556627.jpg";